module.exports = __webpack_public_path__ + "static/media/check.4190ac11.svg";